import styles from './RatingSection.module.scss';
import SectionTitle from '../SectionTitle/SectionTitle';

export default function RatingSection() {
    // Данные рейтингов с путями к иконкам и ссылками на отзывы
    const ratings = [
        {
            id: 'yandex',
            name: 'Яндекс',
            iconPath: '/img/icons/yandex-maps.svg', // Вставь свой путь
            score: '5.0',
            reviews: 'Более 120 отзывов',
            stars: 5,
            gradient: 'linear-gradient(135deg, #FFCC00 0%, #FFB03A 100%)',
            textColor: '#ffffff',
            link: 'https://yandex.ru/maps/org/progium/43718181795/reviews/?ll=49.237891%2C55.747211&z=17'
        },
        {
            id: '2gis',
            name: '2GIS',
            iconPath: '/img/icons/2gis.svg', // Вставь свой путь
            score: '4.9',
            reviews: 'Более 80 отзывов',
            stars: 5,
            gradient: 'linear-gradient(135deg, #A2D534 0%, #76B900 100%)',
            textColor: '#ffffff',
            link: 'https://2gis.ru/kazan/firm/70000001055323412/tab/reviews'
        },
        {
            id: 'google',
            name: 'Google',
            iconPath: '/img/icons/google-maps.png', // Вставь свой путь
            score: '4.8',
            reviews: 'Более 50 отзывов',
            stars: 5,
            gradient: 'linear-gradient(135deg, #4285F4 0%, #3066F7 100%)',
            textColor: '#ffffff',
            link: 'https://www.google.com/maps/place/Прогиум/@55.8231701,49.1234903,17z/data=!4m8!3m7!1s0x415ead5444300001:0x44a29c24f85bf552!8m2!3d55.8231701!4d49.1260652!9m1!1b1!16s%2Fg%2F11kf8cwcfm?hl=ru&entry=ttu&g_ep=EgoyMDI2MDIxOC4wIKXMDSoASAFQAw%3D%3D'
        }
    ];

    // Функция отрисовки 5 звездочек
    const renderStars = (count) => {
        return Array.from({ length: 5 }).map((_, index) => (
            <svg 
                key={index} 
                className={styles.star} 
                viewBox="0 0 24 24" 
                fill={index < count ? "currentColor" : "none"} 
                stroke="currentColor" 
                strokeWidth="2"
            >
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
        ));
    };

    return (
        <section className={styles.ratingSection}>
            <div className="container">
                <SectionTitle>Нам доверяют родители</SectionTitle>
                
                <p className={styles.subtitle}>
                    Честные отзывы на независимых площадках говорят сами за себя
                </p>

                <div className={styles.cardsWrapper}>
                    {ratings.map((item) => (
                        <div 
                            key={item.id} 
                            className={styles.card}
                            style={{ 
                                background: item.gradient,
                                color: item.textColor
                            }}
                        >
                            <div className={styles.cardHeader}>
                                <img 
                                    src={item.iconPath} 
                                    alt={`Рейтинг на ${item.id}`} 
                                    className={styles.brandIcon} 
                                />
                                <div className={styles.brandName}>{item.name}</div>
                                <div className={styles.score}>{item.score}</div>
                            </div>
                            
                            <div className={styles.starsWrapper}>
                                {renderStars(item.stars)}
                            </div>
                            
                            <div className={styles.reviewsText}>
                                {item.reviews}
                            </div>

                            <a 
                                href={item.link} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className={styles.readButton}
                            >
                                Прочитать
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
